export default __webpack_public_path__ + "static/media/mail-generic-negative.2533f74f.svg";